<script setup lang="ts">
import { type User } from '@/stores/user';
import Dropdown from './Dropdown.vue';
const props = defineProps<{ user?: User }>();
</script>

<template>
  <div class="user-card">
    <Dropdown v-if="props.user" :hover="true">
      <template #header>
        <a class="user">
          <div class="pfp"><img :src="props.user.profile_image_url" /></div>
          <div class="username">
            {{ props.user.display_name }}
          </div>
        </a>
      </template>
      <!-- <div class="dropdown-items">
        <a href="#">Settings</a>
        <a href="/logout/">Log Out</a>
      </div> -->
    </Dropdown>

    <a class="user" v-else>
      <div class="pfp"><img src="/images/unknown-user.png" /></div>
      <p>Log In</p>
    </a>
  </div>
</template>

<style scoped>
.user-card .user {
  font-size: 14px;
  font-weight: 700;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  gap: 5px;
}

a.user {
  cursor: pointer;
  border-color: var(--color-orange);
  color: var(--color-orange);
  /* text-transform: uppercase; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

a.user:hover {
  border-color: var(--color-blue);
  color: var(--color-blue);
}

.user .pfp {
  border-radius: 0.55rem;
  min-height: 30px;
  min-width: 30px;
  object-fit: cover;
  background-color: var(--color-grey);
  overflow: hidden;
  border-width: 3px;
  border-style: solid;
  border-color: inherit;
}

.pfp img {
  height: 30px;
  width: 30px;
}

.dropdown-items a {
  border-top: 1px solid var(--color-grey);
  margin-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  display: block;
  width: 100%;
}

.dropdown-items {
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media (max-width: 400px) {

  .username,
  .user p {
    display: none;
  }
}
</style>
